import BaseApi from '@/api/BaseApi'

export default class MapLookupApi extends BaseApi {
    async address (params = {
        Latitude: null,
        Longitude: null
    }) {
        const request = new URLSearchParams()
        request.set('Latitude', params.Latitude)
        request.set('Longitude', params.Longitude)
        const response = await this.get(`api/v1.0/mapLookup/address`, request)

        return response
    }
}
